import { CustomFlowbiteTheme } from 'flowbite-react';

const customTextAreaTheme: CustomFlowbiteTheme['textarea'] = {
    colors: {
        gray: 'bg-gray-50 focus:ring-0 border-gray-300 text-gray-900 dark:border-gray-600 dark:bg-gray-700 dark:text-cirrusWhite dark:placeholder-gray-400',
    },
};

export default customTextAreaTheme;
